import { Expose } from "class-transformer";
import { ITeilleistung } from "./ITeilleistung";

export class Teilleistung implements ITeilleistung {

    teilleistungID: number;
    kostengruppeID: number;
    nummer: number;
    bezeichnung: string;
    bezeichnungGrouping01?: string;
    bezeichnungGrouping02?: string;

    @Expose()
    get anzeige() {
        return this.nummer + ' ' + this.bezeichnung;
    }

    @Expose()
    get grouping01() {
        if (this.nummer < 1000)
            return Math.floor(this.nummer / 100) + '00';
        else
            return Math.floor(this.nummer / 1000) + '000';
    }
    @Expose()
    get grouping02() {
          if (this.nummer < 1000)
            return Math.floor(this.nummer / 10) + '0';
        else
            return Math.floor(this.nummer / 100) + '00';
    }

    constructor(teilleistungID: number, kostengruppeID: number, nummer: number, bezeichnung: string) {
        this.teilleistungID = teilleistungID;
        this.kostengruppeID = kostengruppeID;
        this.nummer = nummer;
        this.bezeichnung = bezeichnung;
    }
}
